<template>
  <DefaultLayout>
  <div class="container-fluid main-content" style="z-index: 1;">
    <div id="progress-bar" class="step-progress-bar">
        <progress-bar
          v-model="currentStep.name" 
          v-bind:type="visitorInformation.visitorType" 
          v-bind:steps="steps"
        />
    </div>
    <FinishMessageTop v-if="currentStep.allowFinish"/>
    <div class="row questions">
      <div class="col">
        <AgentQuestions v-if="currentStep.name == 'agentQuestions'"
            @on-value-entry="onValueEntry"
            @on-agent-info-update="updateAgentInfo"
            @go-to-next-step="goToNextStep" />
        <CustomerQuestions v-if="currentStep.name == 'customerQuestions'"
            @on-customer-info-update="updateCustomerInfo" />
        <Address v-if="currentStep.name == 'address'" 
            v-model="visitorInformation.address"
            v-on:location="getLocation" 
            v-bind:source="visitorInformation.source" 
            v-bind:type="visitorInformation.visitorType"/>
        <ProgramQuestions v-if="currentStep.name == 'programQuestions'"
            @on-value-entry="onValueEntry"
            @on-go-to-step="goToStep" />
        <PropertyQuestions v-if="currentStep.name == 'propertyQuestions'"
            @on-value-entry="onValueEntry"
            @on-go-to-step="goToStep" />
        <PropertyOutdoorQuestions v-if="currentStep.name == 'propertyOutdoorQuestions'"
            @on-value-entry="onValueEntry"
            @on-go-to-step="goToStep" />
        <NeighborhoodQuestions v-if="currentStep.name == 'neighborhoodQuestions'"
            @on-value-entry="onValueEntry"
            @on-go-to-step="goToStep" />
        <OccupantQuestions v-if="currentStep.name == 'occupantQuestions'"
            @on-value-entry="onValueEntry"
            @on-go-to-step="goToStep" />
        <UploadAssets v-if="currentStep.name == 'uploadAssets'"
            @on-upload="saveUploads" />
        <ThankYou v-if="currentStep.name == 'thankYou'" />
      </div>
    </div>
    <div class="row back-next nav-controls">
      <div class="col">
        <b-button 
            pill variant="outline-primary" 
            @click="goBack()" 
            v-show="showBackButton"
            size="lg"
        >
          <span class="back-button-text">Back</span>
        </b-button>
      </div>
      <div v-if="currentStep.allowFinish" class="col">
        <b-button 
            pill variant="outline-primary" 
            @click="finish()"
            size="lg"
            :disabled="disableNextButton"
        >
          <span class="next-button-text">Submit</span>
        </b-button>
      </div>
      <div class="col">
        <b-button 
          pill variant="outline-primary" 
          @click="goNext()" class="button-text"
          v-show="showNextButton"
          size="lg"
          :disabled="disableNextButton"
        >
          <span class="next-button-text"
            v-on:keydown="enterKey"
          >
            {{ nextButtonLabel }}
          </span>
        </b-button>
      </div>
      <div>
        <input id="lead_id" name="lead_id" type="hidden" v-model="leadId" />
      </div>
    </div>
    <section class="row message">      
      <FinishMessageBottom v-if="currentStep.allowFinish"/>
    </section>
  </div>
  <!--
    <template v-slot:footerNav>
      <div class="nav-footer">
        <div>
          <agent-companies v-if="currentStep.name === 'address'"/>
          <TrustPilotReview v-if="isReviewStep" :step="currentStep.name"/>
          <span>Need help? Call <a href="tel:18007504014"> 1-800-750-4014</a></span>
        </div>
        <div>
            <img class="logo" src="https://static.idealagent.com/web/ia/idealagent-logo.png" alt="Ideal Agent Logo" >
        </div>
      </div>
    </template> -->
  <template v-slot:footer>
      <ContentFooter />
  </template>
</DefaultLayout>

</template>

<script>
import DefaultLayout from "@/layout/DefaultLayout.vue";
import Address from "@/components/Address";   
import ProgressBar from "@/components/ProgressBar";    
import AgentQuestions from "@/components/AgentQuestions";
import CustomerQuestions from "@/components/CustomerQuestions";
import NeighborhoodQuestions from "@/components/NeighborhoodQuestions";
import OccupantQuestions from "@/components/OccupantQuestions";
import ProgramQuestions from "@/components/ProgramQuestions";
import PropertyOutdoorQuestions from "@/components/PropertyOutdoorQuestions";
import PropertyQuestions from "@/components/PropertyQuestions";
import UploadAssets from "@/components/UploadAssets";
import ThankYou from "@/components/ThankYou";
import FinishMessageTop from "@/components/disclaimers/FinishMessageTop";
import FinishMessageBottom from "@/components/disclaimers/FinishMessageBottom";
import ContentFooter from "@/components/ContentFooter";
import {propertyTypes} from "@/constants";
import {
  getMapBoxSelections,
  getLastLocationPreference,
  getLocationPreference,
  setKeyValue,
  clearHistory,
  getHistory,
} from "@/utils";
import { saveField, saveCashOffer } from "@/services/apiService";

export default {
  name: "App",
  components: {
    DefaultLayout,
    ContentFooter,
    Address,
    ProgressBar,
    AgentQuestions,
    CustomerQuestions,
    NeighborhoodQuestions,
    ProgramQuestions,
    PropertyQuestions,
    PropertyOutdoorQuestions,
    OccupantQuestions,
    UploadAssets,
    ThankYou,
    FinishMessageTop,
    FinishMessageBottom,
  },
  data() {
    return {
      reviewSteps: [""],
      visitorInformation: {
        address: null,
        propertyType: null,
        timeFrame: null,
        customerInfo: {
          fullName: null,
          phone: null,
          phoneIsValid: null,
          email: null,
        },
        agentInfo: {
          fullName: null,
          phone: null,
          phoneIsValid: null,
          email: null,
        },
        price: 400000,
        buyer: {
          buyQuestion: null,
          buyLocation: null,
        },
        source: null,
        url: null,
        visitorType: null,
      },
      steps: [
        { order: 0, name: "agentQuestions", allowFinish: false },
        { order: 1, name: "customerQuestions", allowFinish: false },
        { order: 2, name: "address", allowFinish: false },
        { order: 3, name: "programQuestions", allowFinish: true },
        { order: 4, name: "propertyQuestions", allowFinish: true },
        { order: 5, name: "propertyOutdoorQuestions", allowFinish: true },
        { order: 6, name: "neighborhoodQuestions", allowFinish: true },
        { order: 7, name: "occupantQuestions", allowFinish: true },
        { order: 8, name: "uploadAssets", allowFinish: true },
        { order: 9, name: "thankYou", allowFinish: false },
      ],
      currentStep: null,
      nextButtonLabel: "Next",
      location: {
        longitude: 0,
        latitude: 0,
      },
      leadId: null,
      mustValidatePhone: null,
      urlParams: undefined,
      attachments: [],
    };
  },
  methods: {
    getLocation: function(newLocation) {
      this.location.latitude = newLocation.lat;
      this.location.longitude = newLocation.lng;
    },
    enterKey: function(event) {
      let key = event.key || event.keyCode;
      if (key === "Enter" && !this.disableNextButton) {
        this.goNext();
      }
    },
    onValueEntry: function(entry) {
      if (entry.saveAs === 'propertyType') {
        this.visitorInformation.propertyType = entry.value;
      }
      setKeyValue(entry.saveAs, entry.value);
    },
    updateAgentInfo: function(agentInfo) {
      this.visitorInformation.agentInfo = agentInfo;
    },
    updateCustomerInfo: function(customerInfo) {
      this.visitorInformation.customerInfo = customerInfo;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    saveUploads(attachments) {
      this.attachments = attachments;
    },
    /**
     * Persists current state of the seller (which should be fully populated) and initiates the sales process
     * */
    saveVisitorInformation: async function() {
      const extraInfo = this.getLocationInformation();

      const cashOfferData = {
        agentEmailAddress: this.visitorInformation.agentInfo.email,
        agentName: this.visitorInformation.agentInfo.fullName,
        agentPhone: this.visitorInformation.agentInfo.phone,
        ...getHistory(),
      };

      cashOfferData.interestedProgram = cashOfferData.interestedProgram || 'CASH_OFFER_ONLY';

      let sellerData = {
        Full_Name: this.visitorInformation.customerInfo.fullName,
        Mobile: this.visitorInformation.customerInfo.phone,
        Email: this.visitorInformation.customerInfo.email,
        Street: this.visitorInformation.address,
        Property_Type: this.getPropertyTypeFromCashOffer(cashOfferData.propertyType),
        Est_Seller_Value: cashOfferData.estimated_value || this.visitorInformation.price,
        Source: this.visitorInformation.source,
        url: this.visitorInformation.url,
        Visitor_Type: "cash",
        Seller_Buyer_or_Both: "NO",
        ...extraInfo,
      };

      const payload = {
        sellerData,
        cashOfferData,
        attachments: this.attachments,
      };

      const res = await saveCashOffer(payload);

      clearHistory();

      if (!this.isEmpty(res)) this.leadId = res.id;
    },
    getPropertyTypeFromCashOffer: function(cashOfferType) {
      return propertyTypes.find(type => type.cashOffer === cashOfferType)?.value;
    },
    getUrlValue: function(fieldName) {
      if (!this.urlParams)
        this.urlParams = new URLSearchParams(window.location.search);
      const value = decodeURIComponent(this.urlParams.get(fieldName));
      return value === "null" ? undefined : value;
    },
    /**
     * Use this function to move to the next screen
     **/
    goNext: function() {
      let nextStep = this.steps[this.getNextStepNumber];
      if (nextStep.name === 'address' && this.visitorInformation.address) {
        nextStep = this.steps[nextStep.order + 1]
      }
      this.currentStep = nextStep;

      if (
        this.currentStep.name == "thankYou" ||
        this.nextButtonLabel === "Finish"
      ) {
        this.saveVisitorInformation();
      }

      if (this.currentStep.name === "thankYou") {
        this.nextButtonLabel = "Finish";
      } else {
        this.nextButtonLabel = "Next";
      }

      this.scrollToTop();
    },
    /**
     * Use this function to move to the previous screen
     **/
    goBack: function() {
      this.currentStep = this.steps[this.getPreviousStepNumber];
      if (this.currentStep.name === "thankYou") {
        this.nextButtonLabel = "Finish";
      } else {
        this.nextButtonLabel = "Next";
      }
      this.scrollToTop();
    },
    finish: function() {
      this.saveVisitorInformation();
      this.goToStep("thankYou");
    },
    /**
     * Watches for single click selections and moves the user to the next screen without needing to click next
     */
    autoProceed: function() {
      // do nothing for now
    },
    getLocationInformation: function() {
      const lastLocation = getLastLocationPreference();
      return getMapBoxSelections(lastLocation);
    },
    goToNextStep: function() {
      this.goNext();
    },
    goToStep(stepName) {
      const step = this.steps.find((s) => s.name === stepName);
      if (step) {
        this.currentStep = step;
      }
    },
    goToLastStep() {
      this.currentStep = this.steps[this.steps.length - 1];
      this.saveVisitorInformation();
    },
  },
  computed: {
    isReviewStep: function() {
      return this.reviewSteps.includes(this.currentStep.name);
    },
    getNextStepNumber: function() {
      return this.currentStep.order + 1;
    },
    getPreviousStepNumber: function() {
      return this.currentStep.order - 1;
    },
    /**
     * Determines if the BACK button should be displayed
     * @returns {boolean|boolean}
     */
    showBackButton: function() {
      return (
        this.currentStep.order > 0 &&
        this.currentStep.order != this.steps.length - 1
      );
    },
    /**
     * Determines if the NEXT button should be displayed
     * @returns {boolean}
     */
    showNextButton: function() {
      return this.currentStep.order < this.steps.length - 1;
    },
    /**
     * Determines if the NEXT button should be enabled based on current step and information filled in
     * @returns {boolean}
     */
    disableNextButton: function() {
      const stepName = this.currentStep.name;

      switch (stepName) {
        case "address":
          return this.isEmpty(this.visitorInformation.address);
        case "agentQuestions":
          return (
            (this.visitorInformation.withAgent === "yes" &&
              this.isEmpty(this.visitorInformation.agentInfo.fullName)) ||
            this.isEmpty(this.visitorInformation.agentInfo.phone) ||
              this.visitorInformation.agentInfo.phone.length !== 10
          );
        case "customerQuestions":
          return (
            this.isEmpty(this.visitorInformation.customerInfo.fullName) ||
            this.isEmpty(this.visitorInformation.customerInfo.phone) ||
              (this.visitorInformation.customerInfo.phone.length !== 10) || 
              this.isEmpty(this.visitorInformation.customerInfo.phoneIsValid)
          );
        case "programQuestions":
          return !this.visitorInformation.address || !this.visitorInformation.propertyType;
        case "propertyQuestions":
          return false;
        case "propertyOutdoorQuestions":
          return false;
        case "neighborhoodQuestions":
          return false;
        case "occupantQuestions":
          return false;
        case "uploadAssets":
          return false;
        default:
          return true;
      }
    },
  },
  watch: {
    visitorInformation: {
      handler: function(newValue) {
        this.autoProceed(newValue);
      },
      deep: true,
    },
  },
  created: async function() {
    let app = this;
    this.currentStep = this.steps[0];

    this.urlParams = new URLSearchParams(window.location.search);
    this.visitorInformation.url = window.location.href;

    // this application is dedicated to cash offers, so set
    this.visitorInformation.visitorType = "cash";

    // get any query string info and store
    let source = this.getUrlValue("source");
    let address = this.getUrlValue("address");
    let lat = this.getUrlValue("lat");
    let lng = this.getUrlValue("lng");

    if (source) {
      this.visitorInformation.source = source;
    } else {
      this.visitorInformation.source = "TV";
    }

    if (address) {
      this.visitorInformation.address = address;
      saveField("Street", this.visitorInformation.address);
      const preference = JSON.parse(getLocationPreference("cash"));
      if (lat && lng) {
        // latitude and longitude are provided in the url, so add
        this.location.latitude = lat;
        this.location.longitude = lng;
      } else if (
        preference &&
        typeof preference.center !== "undefined" &&
        address === preference.place_name
      ) {
        // latitude and longitude are not included in the url, so if the address is a match then pop the values for latitude and longitude
        this.location.latitude = preference.center[1];
        this.location.longitude = preference.center[0];
      } else {
        // no latitude and longitude stored, and address is not the same as in storage, re-ask for location
        this.visitorInformation.address = undefined;
      }
    }

    function showMessageIfFormNotCompleted(e) {
      if (this.currentStep.name != "agentIntroduction") {
        e.preventDefault();
        e.returnValue = "";
      }
    }

    //Prompts the user they are leaving form
    //TODO this should be disabled when form completed
    window.addEventListener(
      "beforeunload",
      function(e) {
        showMessageIfFormNotCompleted(e);
      },
      false
    );

    window.addEventListener("keyup", function(event) {
      app.enterKey(event);
    });
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Montserrat:300,500,700|Lato:300,400,700&display=swap');

body {
    background-color: #fafeff;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 16px;
}

.main-content {
    display: flex;
    flex-direction:column;
    gap: 2rem;
}

.bold {
    font-weight: bold;
}

.fw-400 {
  font-weight: 400 !important;
}

.mb-1 {
  margin-bottom: 1em;
}

.center-80 {
  width: 80%;
  margin: 0px auto;
}

.nav-controls {
  margin-bottom: 1em;
  margin-top: 3em;
}

.next-button-text {
  font-weight: bold;
}

.step-progress-bar {
  margin-bottom: 30px;
  margin-top: 1em;
}

.questions h4 {
  margin-bottom: 1em;
  margin-top: 1em;
  font-weight: bold;
}

.contain {
  width: 90% !important;
  max-width: 600px;
}

.right-side-bar {
  display: block;
  position: fixed;
  background-color: #fbfbfb;
  height: 100vh;
  width: 25%;
  right: 0;
  top: 0;
  z-index: 99;
  box-shadow: 15px 15px 15px 15px #888;
}

.btn-outline-primary.disabled,
.btn-outline-primary:disabled {
  color: #bbbbbb !important;
  border-color: #bbbbbb !important;
  background-color: #f3f3f3 !important;
}

.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .btn-outline-secondary.dropdown-toggle,
.btn-outline-secondary:hover {
  color: #fff !important;
  background-color: #0087ff !important;
  border-color: #0072d8 !important;
}

.nav-footer {
  display:flex;
  flex-direction:column;
  height: 100vh;
  justify-content: space-between;
}

.nav-footer .logo {
  width: 75%;
  padding-bottom: 2rem;
  padding-top: 2rem;
}

@media only screen and (max-width: 480px) {
  #app {
      font-size: 12px;
  }

  .questions h4 {
    font-size: 1.2rem;
  }
}

@media only screen and (max-width: 1000px) {
  .right-side-bar {
    display: none;
  }
}
</style>
